import { withAppContext } from '../../../contexts/AppContext';
import WorkflowControls from './WorkflowControls';

import type { JSX } from 'react';

class AuthorControls extends WorkflowControls {
  protected canEditReviewers: boolean = true;
  protected renderActionControls(disabled: boolean): false | JSX.Element {
    // @ts-expect-error TS2322 - strict migration
    return null;
  }
}

export default withAppContext(AuthorControls);
